// healthCheck.js — prüft beim Start, ob alle Datenbank-Tabellen existieren.
//
// Hintergrund: Die Schema-Skripte (schema.sql, v2…v4) werden manuell im
// Supabase SQL Editor eingespielt. Fehlt eines, schlagen Schreibzugriffe
// still fehl und Daten leben nur lokal. Dieser Check macht das sichtbar.
import { supabase, isSupabaseConfigured } from "./supabase";

const REQUIRED = [
  { table: "patients", script: "schema.sql" },
  { table: "profiles", script: "schema.sql" },
  { table: "stats",    script: "schema_v2_stats.sql" },
  { table: "hkps",     script: "schema_v3_hkps_recalls.sql" },
  { table: "recalls",  script: "schema_v3_hkps_recalls.sql" },
  { table: "settings", script: "schema_v4_settings.sql" },
  { table: "apts",     script: "schema_v7_apts.sql" },
  { table: "reqs",     script: "schema_v8_module_tabellen.sql" },
  { table: "reviews",  script: "schema_v8_module_tabellen.sql" },
  { table: "invoices", script: "schema_v8_module_tabellen.sql" },
  { table: "team_members", script: "schema_v8_module_tabellen.sql" },
  { table: "chat",     script: "schema_v8_module_tabellen.sql" },
  // Spalten-Checks: Tabelle existiert, aber ein späteres Skript fehlt
  { table: "hkps", column: "art", script: "schema_v5_hkp_art.sql" },
  { table: "hkps", column: "archiviert", script: "schema_v5_hkp_art.sql" },
  { table: "hkps", column: "durchgefuehrt_am", script: "schema_v6_hkp_umsetzung.sql" },
  { table: "patients", column: "email", script: "schema_v9_patient_email.sql" },
];

// Gibt fehlende Skripte zurück (dedupliziert) — leeres Array = alles gut.
export async function checkSchema() {
  if (!isSupabaseConfigured) return [];
  const missing = new Set();
  await Promise.all(REQUIRED.map(async ({ table, column, script }) => {
    const { error } = await supabase.from(table).select(column || "*", { head: true, count: "exact" }).limit(1);
    // "relation/column does not exist" / PostgREST kennt Tabelle bzw. Spalte nicht
    if (error && /not exist|not find|schema cache/i.test(error.message || "")) {
      missing.add(script);
    }
  }));
  return [...missing];
}
